import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-catalog" }

import { ref } from "vue";
import { useRoute } from "vue-router";
import set from "@/components/Set/index.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const setsData = [
  {
    title: "全部",
    name: "all",
    id: "7783,7785,7786,7786,7787,7788,7789,7790,7792",
    keyword: "",
  },
  {
    title: "新手引导",
    name: "set0",
    id: "7783",
    keyword: "",
  },
  {
    title: "系统介绍",
    name: "set1",
    id: "7785",
    keyword: "",
  },
  {
    title: "游戏图鉴",
    name: "set2",
    id: "7786",
    keyword: "",
  },
  {
    title: "BOSS介绍",
    name: "set3",
    id: "7787",
    keyword: "",
  },
  {
    title: "版本介绍",
    name: "set4",
    id: "7788",
    keyword: "",
  },
  {
    title: "现金道具",
    name: "set5",
    id: "7789",
    keyword: "",
  },
  {
    title: "次元站公告",
    name: "set6",
    id: "7790",
    keyword: "",
  },
  {
    title: "玩家投稿",
    name: "set7",
    id: "7783,7785,7786,7786,7787,7788,7789,7790,7792",
    keyword: "玩家投稿",
  },
  // {
  //   title: "其他",
  //   name: "set6",
  //   id: "7792",
  //   keyword: ""
  // },
];
// let pageSize = 10

let route = useRoute();
let index = ref("0");

if (route.query.index) {
  index.value = route.query.index as string;
} else {
  index.value = "all";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(set), {
      setsData: setsData,
      maxLength: 9,
      showMore: false,
      "default-value": _unref(index)
    }, null, 8, ["default-value"]))
  ]))
}
}

})